/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio manager API
 * API for tracking portfolio management
 *
 * OpenAPI document version: 1.0.0
 *
 */
import { useMemo } from 'react';
import { queryOptions, useMutation, useQuery, } from '@tanstack/react-query';
import { PropertiesApi, } from '@portfolio-manager/sdk';
import { useApiConfiguration } from '../../api-configuration-context.js';
export const propertiesKeys = {
    all: ['properties'],
    createProperty: () => ['properties', 'createProperty'],
    deleteProperty: () => ['properties', 'deleteProperty'],
    getProperties: (params) => ['properties', 'getProperties', params],
    getProperty: (params) => ['properties', 'getProperty', params],
    updateProperty: () => ['properties', 'updateProperty'],
    updatePropertyNotes: () => ['properties', 'updatePropertyNotes'],
};
export function usePropertiesApi() {
    const configuration = useApiConfiguration();
    return useMemo(() => new PropertiesApi(configuration), [configuration]);
}
export function usePropertiesCreateProperty(options) {
    const api = usePropertiesApi();
    return useMutation({
        mutationKey: propertiesKeys.createProperty(),
        mutationFn: (params) => api.createProperty(params),
        ...options,
    });
}
export function usePropertiesDeleteProperty(options) {
    const api = usePropertiesApi();
    return useMutation({
        mutationKey: propertiesKeys.deleteProperty(),
        mutationFn: (params) => api.deleteProperty(params),
        ...options,
    });
}
export const propertiesGetPropertiesQueryOptions = (api, params) => queryOptions({
    queryKey: propertiesKeys.getProperties(params),
    queryFn: ({ signal }) => api.getProperties(params, { signal }),
});
export function usePropertiesGetProperties(params, options) {
    const api = usePropertiesApi();
    return useQuery({ ...propertiesGetPropertiesQueryOptions(api, params), ...options });
}
export const propertiesGetPropertyQueryOptions = (api, params) => queryOptions({
    queryKey: propertiesKeys.getProperty(params),
    queryFn: ({ signal }) => api.getProperty(params, { signal }),
});
export function usePropertiesGetProperty(params, options) {
    const api = usePropertiesApi();
    return useQuery({ ...propertiesGetPropertyQueryOptions(api, params), ...options });
}
export function usePropertiesUpdateProperty(options) {
    const api = usePropertiesApi();
    return useMutation({
        mutationKey: propertiesKeys.updateProperty(),
        mutationFn: (params) => api.updateProperty(params),
        ...options,
    });
}
export function usePropertiesUpdatePropertyNotes(options) {
    const api = usePropertiesApi();
    return useMutation({
        mutationKey: propertiesKeys.updatePropertyNotes(),
        mutationFn: (params) => api.updatePropertyNotes(params),
        ...options,
    });
}
//# sourceMappingURL=properties-api.js.map